import { query_shop_target_list } from '@/api/mjstat-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';

import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/views/month-target/month-target-config.ts';

import { reactive } from 'vue';

export default () => {
  const None = null;
  const True = true;
  const False = false;
  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'monthpicker',
        name: 'date',
        label: '月份',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        format: 'YYYY-MM',
        valueFormat: 'YYYY-MM',
        placeholder: '请选择月份',
      },
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '门店',
        disabled: false,
        placeholder: '请选择执行门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
    ],
    rules: {
      date: [{ required: true, message: '请输入月份' }],
    },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      date: null,
      shop_id: null,
    }),
  };
  const search_options = {};

  const edit_model_config = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    watch: {},
    model: reactive({}),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '',
    addModalTitle: '',
    updateTitle: '',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '月份',
      dataIndex: 'date',
      width: 100,
      fixed: 'left',
    },
    {
      title: '门店编码',
      width: 120,
      dataIndex: 'shop__code',
      fixed: 'left',
      checked: true,
    },
    {
      title: '门店名称',
      width: 120,
      dataIndex: 'shop__name',
      fixed: 'left',
      checked: true,
    },
    {
      title: '上年同期收款金额',
      width: 150,
      dataIndex: 'data.A',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '本月收款目标',
      width: 150,
      dataIndex: 'data.B',
      checked: true,
    },
    {
      title: '上年同期人均收款金额',
      width: 160,
      dataIndex: 'data.C',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '本月人均收款目标',
      width: 150,
      dataIndex: 'data.D',
      checked: true,
    },
    {
      title: '上年同期耗卡金额',
      width: 150,
      dataIndex: 'data.E',
      checked: true,
      slots: { customRender: 'round_price' },
    },
    {
      title: '本月耗卡目标',
      width: 150,
      dataIndex: 'data.F',
      checked: true,
    },
    {
      title: '上年同期客流量',
      width: 150,
      dataIndex: 'data.G',
      checked: true,
    },
    {
      title: '本月客流目标',
      width: 150,
      dataIndex: 'data.H',
      checked: true,
    },
    {
      title: '操作',
      width: 80,
      dataIndex: 'action',
      checked: true,
      slots: { customRender: 'action' },
      fixed: 'right',
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push();

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_shop_target_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
